import script from "./page_01.vue?vue&type=script&setup=true&lang=js"
export * from "./page_01.vue?vue&type=script&setup=true&lang=js"

import "./page_01.vue?vue&type=style&index=0&id=24acf776&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d637f08be657c424b9582f6be932ff98/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24acf776"]])

export default __exports__